export const stringHasCharacters = (text: any = "", size: number = 1) =>
  text && text.length >= size
